export function formatPercentage(value?: number | null, digits?: number) {
	if (value === undefined || value === null) {
		return "-";
	}
	return "" + (value * 100).toFixed(digits || 2) + "%";
}
